import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { borderRadius } from "@mui/system";
import Tooltip from "@mui/material/Tooltip";
import { useAuth } from "../../Auth";
import SwiperPager from "../../controls/swiperPager";
import api from "../../services/api";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/grid";
import "swiper/css/pagination";

// import required modules
import { Grid, Keyboard, Pagination } from "swiper/modules";
import videoIcon from "../../assets/images/icn-video-o.png";
import articleIcon from "../../assets/images/icn-article-o.png";
import blogIcon from "../../assets/images/icn-blog-o.png";
import logo from "../../assets/images/logo-cumanagement-cues.png";
import arrowIcon from "../../assets/images/icn-arrow-r.png";

const ArticlesElement = styled.section`
  display: flex;
  justify-content: center;
  background: #f1f1f1;
  padding: 52px 20px 70px 20px;
  .pagination {
    list-style: none;
    height: 31.5px;
    width: 31.5px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto; /* Center the pagination horizontally */
    margin-top: 2px;
    cursor: pointer;
  }
  .pagination li a {
    /**width: 25px !important;**/
    height: 25px !important;
    background-color: transparent;
    color: #000;
    align-items: center;
    justify-content: center;
   
    cursor: pointer;
    text-align: center !important;
    font-size: 12px; /* Adjust font size as needed */
    line-height: .75; /* Ensure the number is properly contained within the box */
    padding:5px!important;
    padding-top:7px!important;
   
    margin: 5px;
    border: 1px solid #000; /* Add a white border */
  }
  .pagination .break  a {
    border: 1px solid transparent!important; /* Add a white border */
  }
  .hidden {
    display: none;
  }
  .active a {
    background-color: #000!important;
    color: #fff!important;
    
  }
  .cmp-articles-container {
    max-width: 1280px;
    width: 100%;
  }

  .cmp-articles-header {
    margin-bottom: 34px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 865px) {
      flex-direction: column;
      align-items: flex-start;
    }

    @media (max-width: 630px) {
      align-items: center;
      margin-bottom: 50px;
    }

    .cmp-articles-branding {
      @media (max-width: 630px) {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      img {
        max-width: 526px;
        width: 100%;
        height: auto;
        margin-bottom: 6px;

        @media (max-width: 630px) {
          margin-bottom: 10px;
        }
      }

      p {
        font-size: 14px;
        line-height: 12px;
        letter-spacing: 0.42px;
        font-weight: 500;
        color: #303440;
        text-transform: uppercase;

        @media (max-width: 630px) {
          text-align: center;
          line-height: 18px;
        }
      }
    }

    a.cmp-articles-button {
      @media (max-width: 865px) {
        margin-top: 20px;
      }

      border-radius: 30px;
      background: #2D66AC;
      border: 2px solid #2D66AC;
      text-decoration: none;
      color: #fff;
      font-size: 14px;
      font-weight: 800;
      line-height: 22px;
      letter-spacing: 0;
      padding: 4px 24px;
    }
  }

  .cmp-articles-feed {
    overflow-x: scroll;
    margin: 0 calc(50% - 50vw);
    padding-left: calc((100vw - 1280px) / 2);
    padding-right: calc((100vw - 1280px) / 2);
    padding-bottom: 10px;
    .swiper {
      overflow: visible;
      padding-bottom: 50px;

      .swiper-pagination {
        bottom: 0px;

        .swiper-pagination-bullet {
          height: 15px;
          width: 15px;
          background: none;
          border: 2px solid #878990;
          opacity: 1;

          &:not(:last-of-type) {
            margin-right: 10px;
          }

          &.swiper-pagination-bullet-active {
            background: #E2680E;
            border: 2px solid #E2680E;
          }
        }
      }
    }
    .swiper-slide {
      width: 375px;
      
      @media (max-width: 400px) {
        width: 100%;
        max-width: 375px;
      }
    }
    @media (max-width: 520px) {
      display: none;
    }

    /* Hide scroll bar */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    scrollbar-width: none; /* Firefox */

    &::-webkit-scrollbar {
      display: none; /* Safari and Chrome */
    }

    ul {
      display: flex;

      @media (max-width: 1300px) {
        padding-left: 20px;
      }

      li {
        &:not(:last-child) {
          margin-right: 16px;
        }
      }
    }
  }

  .cmp-articles-feed-mobile {
    @media (min-width: 521px) {
      display: none;
    }

    .cmp-article-card {
      margin-right: auto;
      margin-left: auto;
    }

    .swiper {
      padding-bottom: 50px;

      .swiper-pagination {
        bottom: 0px;

        .swiper-pagination-bullet {
          height: 15px;
          width: 15px;
          background: none;
          border: 2px solid #878990;
          opacity: 1;

          &:not(:last-of-type) {
            margin-right: 10px;
          }

          &.swiper-pagination-bullet-active {
            background: #E2680E;
            border: 2px solid #E2680E;
          }
        }
      }
    }
  }

  .cmp-article-card {
    width: 375px;
    height: 425px;
    border-radius: 8px;
    background: #fff;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 3px 6px #00000029;

    @media (max-width: 400px) {
      width: 100%;
      max-width: 375px;
      height: 450px;
    }

    .cmp-article-card-header {
      height: 225px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center top;
      border-radius: 8px 8px 0 0;
      position: relative;

      .cmp-article-card-read-time {
        position: absolute;
        bottom: 14px;
        left: 10px;
        color: #fff;
        font-size: 14px;
        line-height: 16px;
        font-weight: 500;
        padding: 4px 6px;
        border-radius: 5px;
        background: rgba(0, 0, 0, 0.65);
      }
    }

    .cmp-article-card-content {
      padding: 16px 20px 38px 20px;
      flex: 1;
      display: flex;
      flex-direction: column;

      @media (max-width: 400px) {
        padding: 14px 18px 32px 18px;
      }

      .cmp-article-card-type {
        margin-bottom: 15px;
        

        p {
          font-size: 15px;
          line-height: 19px;
          font-weight:800;
          text-transform: uppercase;
          color: #E2680E;
          display: flex;
          align-items: center;
          font-family:'Nunito Sans', sans-sarif;
          img {
            height: 16px;
            width: auto;
            margin-right: 8px;
          }
        }
      }

      .cmp-article-card-date,
      .cmp-article-card-author {
        font-size: 16px;
        font-weight: 700!important;
        line-height: 22px;
        
        color: #2f3234;
      }

      .cmp-article-card-title {
        font-size: 20px;
        font-weight:700!important;
       
        line-height: 26px;
       
        color: #000000;
        margin-top: 6px;
        text-decoration: none;
        
        @media (max-width: 400px) {
          font-size: 18px;
          line-height: 24px;
          margin-top: 4px;
        }
      }

      .cmp-article-card-author {
        margin-top: auto;
      }
    }
  }
`;

const CUManagementSection = () => {

  const { cmpData, cmanURL, cuesURL, environment, canSectionLoad, markSectionLoaded } = useAuth();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentSwiper, setCurrentSwiper] = useState(null);
  // Fetch articles data when this section can load
  useEffect(() => {
    if (cmpData && canSectionLoad('cmp_cu_management') && articles.length === 0) {
      const articlesApiUrl = cuesURL + "/cmp/articles";
      
      api.get(articlesApiUrl)
        .then(function (response) {
          setArticles(response.data);
          setLoading(false);
          markSectionLoaded('cmp_cu_management');
        })
        .catch(function (error) {
          setLoading(false);
          markSectionLoaded('cmp_cu_management'); // Mark as loaded even on error
        });
    }
  }, [cmpData, canSectionLoad, cuesURL, articles.length, markSectionLoaded]);

  function handleGAEvent(eventTitle, value) {
    if (cmpData) {
      // if (window.location.host == "mycues.cues.org") {
        // Push event to GTM data layer
        if (window.dataLayer) {
          window.dataLayer.push({
            event: eventTitle,
            event_category: 'CU Management',
            event_label: value,
            value: value,
            user_role: cmpData.account_info.acgiRole,
            user_memberlevel: cmpData.account_info.membershipLevel,
            user_company: cmpData.account_info.employer,
          });
        }
      // }
    }
  }

  if (loading) {
    return null; // Or return a loading skeleton
  }

  return (
    <ArticlesElement>
      <div className="cmp-articles-container">
        <div className="cmp-articles-header">
          <div className="cmp-articles-branding">
            <img src={logo} alt="CUManagement Logo" />
            <p>
              PROVIDING INSIGHTS FOR TODAY'S PROGRESSIVE CREDIT UNION
              LEADERS.
            </p>
          </div>

          <a
            href={cuesURL + "/cumanagement-external"}
            target="_blank"
            rel="noopener noreferrer"
            className="cmp-articles-button"
            onClick={() => {
              handleGAEvent("cumanagement_visit");
            }}
          >
            ACCESS MORE CONTENT
          </a>
        </div>

        <div className="cmp-articles-feed">
          <Swiper
            simulateTouch={true}
            slidesPerView={"auto"}
            slidesPerGroup={3}
            spaceBetween={30}
            keyboard={{
              enabled: true,
            }}
            pagination={{
              type: 'none'
            }}
            modules={[Pagination, Keyboard]}
            className="mySwiper"
          >
            <>
              {articles.map((article) => (
                <SwiperSlide key={article.id || article.url}>
                  <div
                    className="cmp-article-card"
                    data-node-id={article.id}>
                    <div
                      className="cmp-article-card-header"
                      style={{
                        backgroundImage: article.image
                          ? `url("${article.image}")`
                          : "none",
                      }}
                    >
                      {article.length && (
                        <p className="cmp-article-card-read-time">
                          {article.length}
                        </p>
                      )}
                    </div>

                    <div className="cmp-article-card-content">
                      {article.type && (
                        <div className="cmp-article-card-type">
                          {/* Article */}
                          {article.type.toLowerCase() == "article" && (
                            <p>
                              <img src={articleIcon} alt="Article" /> Article
                            </p>
                          )}

                          {/* Blog */}
                          {article.type.toLowerCase() == "blog" && (
                            <p>
                              <img src={blogIcon} alt="Blog" /> Blog
                            </p>
                          )}

                          {/* Video */}
                          {article.type.toLowerCase() == "video" && (
                            <p>
                              <img src={videoIcon} alt="Video" /> Video
                            </p>
                          )}
                        </div>
                      )}

                      {article.date && (
                        <p className="cmp-article-card-date">{article.date}</p>
                      )}

                      <a
                        href={article.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cmp-article-card-title"
                        onClick={() => {
                          handleGAEvent("cumanagement_access", article.url);
                        }}
                      >
                        {article.title}
                      </a>

                      {article.author && (
                        <p className="cmp-article-card-author">
                          By {article.author}
                        </p>
                      )}
                    </div>
                  </div>
                </SwiperSlide>


              ))}
            </>
          </Swiper>
        </div>

        <div className="cmp-articles-feed-mobile">
          <Swiper
            simulateTouch={true}
            slidesPerView={1}
            slidesPerGroup={1}
            spaceBetween={30}

            keyboard={{
              enabled: true,
            }}
            onSwiper={(swiper) => setCurrentSwiper(swiper)}
            pagination={{
              clickable: true,
              renderBullet: function (index, className) {
                return ``;
              }
            }}
            modules={[Pagination, Keyboard]}
            className="mySwiper"
          >
            <>
              {articles.slice(0, 10).map((article) => (
                <SwiperSlide key={article.id || article.url}>
                  <div
                    className="cmp-article-card"
                    data-node-id={article.id}>
                    <div
                      className="cmp-article-card-header"
                      style={{
                        backgroundImage: article.image
                          ? `url("${article.image}")`
                          : "none",
                      }}
                    >
                      {article.length && (
                        <p className="cmp-article-card-read-time">
                          {article.length}
                        </p>
                      )}
                    </div>

                    <div className="cmp-article-card-content">
                      {article.type && (
                        <div className="cmp-article-card-type">
                          {/* Article */}
                          {article.type.toLowerCase() == "article" && (
                            <p>
                              <img src={articleIcon} alt="Article" /> Article
                            </p>
                          )}

                          {/* Blog */}
                          {article.type.toLowerCase() == "blog" && (
                            <p>
                              <img src={blogIcon} alt="Blog" /> Blog
                            </p>
                          )}

                          {/* Video */}
                          {article.type.toLowerCase() == "video" && (
                            <p>
                              <img src={videoIcon} alt="Video" /> Video
                            </p>
                          )}
                        </div>
                      )}

                      {article.date && (
                        <p className="cmp-article-card-date">{article.date}</p>
                      )}

                      <a
                        href={article.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cmp-article-card-title"
                        onClick={() => {
                          handleGAEvent("cumanagement_access", article.url);
                        }}
                      >
                        {article.title}
                      </a>

                      {article.author && (
                        <p className="cmp-article-card-author">
                          by {article.author}
                        </p>
                      )}
                    </div>
                  </div>
                </SwiperSlide>

              ))}
            </>
          </Swiper>
          <SwiperPager swiper={currentSwiper} itemCount={articles.slice(0, 18).length} pageRangeCount={8}
            itemsPerPage={9} currentPage={0} isSinglePerPage={true}></SwiperPager>

        </div>
      </div>
    </ArticlesElement>
  );
};

export default CUManagementSection;
